<template>
  <!-- 组件 -->
  <div class="company_page">
     <div class="company_title" @click="selTabber(4)">
      公司介绍
    </div>
    <div class="company_warn">
      以数智技术为核心的建筑垃圾行业信息化和产业化经营解决方案提供商
    </div>
    <div class="company_content">
      <div class="company_introducte"> 
        <div class="introducte_left">
          <img class=" exhibit_img left_img" src="/static/img/index/company.png" alt="">
          <!-- <video class="left_img" v-if="isVideo" controls muted autoplay loop>
            <source src="/static/img/common/video.mp4" type="video/mp4">
          </video> -->
        </div> 
        <div class="introducte_right">
          <div class="right_name">
            <div class="name_box">
              <div class="about">
                ABOUT US
              </div>
              <div class="name_title">
                小绿（青岛）环境科技有限公司
              </div>
            </div>
            <div class="right_img">
              <img class="img_end" src="/static/img/index/end.png" alt="">
            </div>
          </div>
          <!-- <img class="up_icon" src="/static/img/index/upMarks.png" alt=""> -->
          <div class="introducte_word">
            <div class="introducte_text">
              小绿（青岛）环境科技有限公司是一家面向工程建设行业的科技型综合服务企业。公司旨在以数字化驱动行业治理方式变革，以科技创新赋能行业产业化升级，重构产业链价值，促进新形势下建筑垃圾综合利用行业高质量发展。
            </div>
            <div class="goto" @click="selTabber(4)">
              了解更多 <img class="goto_arrow" src="/static/img/common/arrow.png" alt="">
            </div>
          </div>

          <!-- <img class="down_icon" src="/static/img/index/downMarks.png" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //视频播放
      isVideo:false,
      //动画播放
      animation: false,
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {
    var topPage = document.querySelector('.company_page')
    window.addEventListener('scroll',()=>{
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //获取距离顶部高度
      let pageTop =
        topPage.getBoundingClientRect().top
      let windowTop =
        window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      // 滚动大于500显示
        if(scrollTop >= pageTop && !this.animation){
          this.animation = true
          console.log("topPage",topPage.getBoundingClientRect().top, )
        }
      })
  },
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    selTabber(e){
      this.$emit('selTabber',e)
    }
  },
};
</script>

<style scoped lang="scss">
@import url(../home.css);
@media screen and ( min-width: 1200px ) {
  .company_page{
    display: flex;
    flex-direction: column;
    align-items: center;
    .company_content{
      margin-top: 30px;
      width: 1920px;
      display: flex;
      justify-content: center; 
      .company_introducte{
        background-image: url('/static/img/index/bg.png');
        background-size: 100% 100%;
        width: 1200px;
        height: 338px;
        display: flex;
        position: relative;
        .introducte_left{
          width: 547px;
          height: 308px;
          margin-left: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          .exhibit_img:hover{
            transform:scale(1.05);  
          }
          .left_img{
            width: 600px;
            height: 338px;
            cursor:pointer;
            transition : all 0.5s ease-in-out;
          }
        }
        .introducte_right{
          margin-left: 40px;
          width: 543px;
          .right_name{
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            .name_box{
              border-left: 2px solid #0EA049;
              padding-left: 10px;
              box-sizing: border-box;
              .about{
                font-weight: bold;
                font-size: 32px;
                color: #0EA049;
              }
              .name_title{
                font-size: 16px;
                font-weight: bold;
              }
            }
            .right_img{
              .img_end{
                width: 38px;
              }
            }
          }
          .up_icon{ 
            width: 43px;
            height: 36px;
            margin: 0 0 0 33px;
            box-sizing: border-box;
          }
          .introducte_text{
            margin-top: 26px;
            box-sizing: border-box; 
            letter-spacing: 0.02em;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            /* or 22px */
            text-align: justify;
            text-indent: 2em;
          }
          .goto{
            width: 115px;
            height: 36px;
            box-sizing: border-box;
            border: 1px solid #0EA049;
            border-radius: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #0EA049;
            margin: 37px 0 0 0 ;
            cursor: pointer;
            .goto_arrow{
              width: 16px;
              margin-left: 5px;
            }
          }
          .down_icon{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 43px;
            height: 36px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
@media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
  .company_page{
    display: flex;
    flex-direction: column;
    align-items: center;
    .company_content{
      margin-top: 1.875rem;
      width: 120rem;
      display: flex;
      justify-content: center; 
      .company_introducte{
        background-image: url('/static/img/index/bg.png');
        background-size: 100% 100%;
        width: 75rem;
        height: 21.125rem;
        display: flex;
        position: relative;
        .introducte_left{
          width: 34.1875rem;
          height: 19.25rem;
          margin-left: 1.875rem;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          .exhibit_img:hover{
            transform:scale(1.05);  
          }
          .left_img{
            width: 37.5rem;
            height: 21.125rem;
            cursor:pointer;
            transition : all 0.5s ease-in-out;
          }
        }
        .introducte_right{
          margin-left: 2.5rem;
          width: 33.9375rem;
          .right_name{
            margin-top: 1.25rem;
            display: flex;
            justify-content: space-between;
            .name_box{
              border-left: .125rem solid #0EA049;
              padding-left: .625rem;
              box-sizing: border-box;
              .about{
                font-weight: bold;
                font-size: 2rem;
                color: #0EA049;
              }
              .name_title{
                font-size: 1rem;
                font-weight: bold;
              }
            }
            .right_img{
              .img_end{
                width: 2.375rem;
              }
            }
          }
          .up_icon{ 
            width: 2.6875rem;
            height: 2.25rem;
            margin: 0 0 0 2.0625rem;
            box-sizing: border-box;
          }
          .introducte_text{
            margin-top: 1.625rem;
            box-sizing: border-box; 
            letter-spacing: 0.02em;
            font-weight: 400;
            font-size: .875rem;
            line-height: 1.5rem;
            /* or 1.375rem */
            text-align: justify;
            text-indent: 1.875rem;
          }
          .goto{
            width: 7.1875rem;
            height: 2.25rem;
            box-sizing: border-box;
            border: .0625rem solid #0EA049;
            border-radius: 3.125rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .875rem;
            color: #0EA049;
            margin: 2.3125rem 0 0 0 ;
            cursor: pointer;
            .goto_arrow{
              width: 1rem;
              margin-left: .3125rem;
            }
          }
          .down_icon{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 2.6875rem;
            height: 2.25rem;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
@media screen and ( max-width: 1000px ) {
  .company_page{
    display: flex;
    flex-direction: column;
    align-items: center;
    .company_content{
      margin-top: .625rem;
      width: 23.4375rem;
      // height: 9056px;
      display: flex;
      justify-content: center; 
      .company_introducte{
        width: 23.4375rem;
        // height: 8000px;
        // display: flex;
        position: relative;
        .introducte_left{
          // display: none;
          // width: 17568px;
          // height: 9888px;
          margin-left: 1rem;
          .left_img{
            width: 21.4375rem;
            height: 12.0625rem;
          }
        }
        .introducte_right{
          background-image: url('/static/img/index/introduce.png');
          background-size: cover;
          width: 23.4375rem;
          margin-top: .75rem;
          padding: 0 1rem;
          padding-bottom: 1rem;
          box-sizing: border-box;
          .right_name{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name_box{
              border-left: .125rem solid #0EA049;
              padding-left: .3125rem;
              box-sizing: border-box;
              .about{
                font-weight: bold;
                font-size: 1.125rem;
                color: #0EA049;
              }
              .name_title{
                font-size: .75rem;
                font-weight: bold;
              }
            }
            .right_img{
              .img_end{
                width: 1.5rem;
              }
            }
          }
          .introducte_text{
            margin-top: .75rem;
            box-sizing: border-box; 
            letter-spacing: 0.02em;
            font-size: .875rem;
            line-height: 1.375rem;
            font-weight: 400;
            text-align: justify;
            text-indent: 1.875rem;
          }
          .goto{
            width: 5.625rem;
            height: 1.6875rem;
            box-sizing: border-box;
            border: .0625rem solid #0EA049;
            border-radius: 3.125rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .75rem;
            color: #0EA049;
            margin: .625rem 0 0 0 ; 
            cursor: pointer;
            .goto_arrow{
              width: .75rem;
              margin-left: .3125rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/home-company.vue